export const ATOMIC_COMPONENTS = {
    FORM: {
        DROPDOWN_POPOVER_FIELD: {
            ROOT: "atomic-components_dropdown-popover-field_root",
            LABEL: "atomic-components_dropdown-popover-field_label",
        },
    },
    ACCORDION: {
        ROOT: "atomic-components_accordion_root",
        SUMMARY: "atomic-components_accordion_summary",
        DETAILS: "atomic-components_accordion_details",
    },
};
